export const DAO_CODE = 'CONTRACTOR' + 'INVOICES' + '_DAO';
